export const APP_NAME = 'Tailor Loop'

// Single source of truth for the absolute URL of the running app.
// Used in OAuth redirects, canonical links, Stripe return URLs, etc.
//
// In production VITE_APP_URL must be set on Vercel. Fall back to localhost
// only in dev. If we silently used localhost in a deployed build, every
// redirect (Stripe checkout return, OAuth callback, sitemap canonicals)
// would point at a dev machine — fail loudly here so the misconfiguration
// is visible immediately in the browser console.
const _envAppUrl = (import.meta.env.VITE_APP_URL ?? '').trim()
if (!_envAppUrl && import.meta.env.PROD) {
  console.error(
    '[constants] VITE_APP_URL is not set in production build. ' +
    'OAuth redirects + canonical links will be broken. Set it in Vercel.',
  )
}
export const APP_URL = _envAppUrl || 'http://localhost:5175'

export const CAMPAIGN_STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  building: 'Building',
  active: 'Active',
  paused: 'Paused',
  completed: 'Completed',
  failed: 'Failed',
}

export const EMAIL_TASK_STATUS_LABELS: Record<string, string> = {
  pending: 'Pending',
  composing: 'Composing',
  ready: 'Ready',
  queued: 'Queued',
  paused: 'Paused',
  sending: 'Sending',
  sent: 'Sent',
  failed: 'Failed',
  bounced: 'Bounced',
}

export const ROUTES = {
  LOGIN: '/login',
  SIGNUP: '/signup',
  AUTH_CALLBACK: '/auth/callback',
  DASHBOARD: '/',
  CAMPAIGNS: '/campaigns',
  CAMPAIGN_NEW: '/campaigns/new',
  CAMPAIGN_DETAIL: '/campaigns/:id',
  CONTACTS: '/contacts',
  CONTACT_DETAIL: '/contacts/:id',
  SETTINGS: '/settings',
} as const
